import React, { useState } from "react";
import { Mail, CheckCircle, Bell, ArrowRight } from "lucide-react";

const NewsletterSection = () => {
    const [email, setEmail] = useState("");
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Simulate API call
        setTimeout(() => {
            setIsSubscribed(true);
            setIsLoading(false);
            setEmail("");
        }, 1500);
    };

    const benefits = [
        "Early access to hackathons and events",
        "Weekly funding opportunities",
        "Innovation insights and trends",
        "Community success stories"
    ];

    return (
        <section className="bg-white py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {!isSubscribed ? (
                    <div className="grid lg:grid-cols-2 gap-16 items-center">
                        {/* Left Content */}
                        <div>
                            <div className="flex items-center gap-2 mb-6">
                                <Bell className="w-5 h-5 text-custom-bg-green" />
                                <span className="text-sm font-medium text-gray-600 uppercase tracking-wide">
                                    Newsletter
                                </span>
                            </div>
                            
                            <h2 className="text-4xl md:text-5xl font-bold text-custom-blue-1 mb-6 leading-tight">
                                Stay Updated with Innovation
                            </h2>
                            
                            <p className="text-lg text-custom-blue-1/70 mb-8 leading-relaxed">
                                Get weekly updates on hackathons, funding opportunities, and innovation insights 
                                delivered directly to your inbox.
                            </p>

                            <div className="space-y-4">
                                {benefits.map((benefit, index) => (
                                    <div key={index} className="flex items-center gap-3">
                                        <div className="flex-shrink-0 w-5 h-5 rounded-full bg-custom-bg-green/10 flex items-center justify-center">
                                            <CheckCircle className="w-3 h-3 text-custom-bg-green" />
                                        </div>
                                        <span className="text-custom-blue-1/80">
                                            {benefit}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Right Form */}
                        <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
                            <div className="space-y-6">
                                <div>
                                    <label className="block text-sm font-medium text-custom-blue-1 mb-2">
                                        Email Address
                                    </label>
                                    <div className="relative">
                                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="your@email.com"
                                            className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 bg-white text-custom-blue-1 placeholder-gray-400 focus:outline-none focus:border-custom-bg-green focus:ring-2 focus:ring-custom-bg-green/20 transition-colors duration-200"
                                        />
                                    </div>
                                </div>

                                <button
                                    onClick={handleSubmit}
                                    disabled={isLoading}
                                    className="w-full py-3 bg-custom-bg-green text-white font-medium rounded-lg hover:opacity-90 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {isLoading ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                            Subscribing...
                                        </>
                                    ) : (
                                        <>
                                            Subscribe
                                            <ArrowRight className="w-4 h-4" />
                                        </>
                                    )}
                                </button>

                                <p className="text-xs text-gray-500 text-center">
                                    We respect your privacy. Unsubscribe anytime.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    /* Success State */
                    <div className="text-center bg-gray-50 rounded-xl p-12 border border-gray-200 max-w-2xl mx-auto">
                        <div className="w-16 h-16 bg-custom-bg-green rounded-full flex items-center justify-center mx-auto mb-6">
                            <CheckCircle className="w-8 h-8 text-white" />
                        </div>
                        
                        <h3 className="text-2xl font-bold text-custom-blue-1 mb-4">
                            Successfully Subscribed!
                        </h3>
                        
                        <p className="text-custom-blue-1/70 mb-8">
                            Thank you for subscribing. You'll receive weekly updates on innovation opportunities 
                            and insights directly to your inbox.
                        </p>
                        
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                onClick={() => setIsSubscribed(false)}
                                className="px-6 py-3 border border-custom-bg-green text-custom-bg-green rounded-lg hover:bg-custom-bg-green hover:text-white transition-colors duration-200"
                            >
                                Subscribe Another Email
                            </button>
                            <button className="px-6 py-3 bg-custom-bg-green text-white rounded-lg hover:opacity-90 transition-opacity duration-200">
                                Browse Events
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default NewsletterSection;